import React from 'react';
import { Upload, Camera, FileText, Image } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

function getFileIcon(filename) {
  const ext = filename.split('.').pop().toLowerCase();
  if (['png', 'jpg', 'jpeg', 'webp'].includes(ext)) return <Image className="w-5 h-5 text-zinc-400" />;
  return <FileText className="w-5 h-5 text-zinc-400" />;
}

export function FileDropZone({
  files, dragActive, uploading, isFree, devMode,
  onDrag, onDrop, onFileSelect, onRemoveFile, onUpload,
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Upload Bank Statements</CardTitle>
      </CardHeader>
      <CardContent>
        <div
          className={`upload-zone ${dragActive ? 'dragging' : ''}`}
          onDragEnter={onDrag} onDragLeave={onDrag} onDragOver={onDrag} onDrop={onDrop}
          data-testid="upload-dropzone"
        >
          <input type="file" id="file-upload" className="hidden" multiple
            accept={(isFree && !devMode) ? ".pdf,.csv" : ".pdf,.csv,.png,.jpg,.jpeg,.webp"}
            onChange={onFileSelect} data-testid="file-input" />
          <label htmlFor="file-upload" className="cursor-pointer">
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                <Upload className="w-8 h-8 text-[#D94E18]" />
              </div>
              <p className="text-zinc-900 font-medium mb-1">Drag & drop files here</p>
              <p className="text-sm text-zinc-500 mb-4">or click to browse</p>
              <p className="text-xs text-zinc-400">Supported: PDF, CSV, PNG, JPG, WEBP</p>
            </div>
          </label>
        </div>

        <div className="mt-4 md:hidden">
          <input type="file" id="camera-upload" className="hidden" accept="image/*" capture="environment" onChange={onFileSelect} data-testid="camera-input" />
          <label htmlFor="camera-upload">
            <Button variant="outline" className="w-full" asChild>
              <span className="flex items-center gap-2"><Camera className="w-5 h-5" />Take Photo</span>
            </Button>
          </label>
        </div>

        {files.length > 0 && (
          <div className="mt-6 space-y-2">
            <p className="text-sm font-medium text-zinc-700">Selected Files ({files.length})</p>
            {files.map((file, index) => (
              <div key={file.name} className="flex items-center justify-between p-3 bg-zinc-50 rounded-lg" data-testid={`selected-file-${index}`}>
                <div className="flex items-center gap-3">
                  {getFileIcon(file.name)}
                  <span className="text-sm text-zinc-700 truncate max-w-[150px] sm:max-w-[200px]">{file.name}</span>
                </div>
                <button onClick={() => onRemoveFile(index)} className="text-zinc-400 hover:text-red-500 transition-colors" data-testid={`remove-file-${index}`}>x</button>
              </div>
            ))}
            <Button onClick={onUpload} disabled={uploading} className="w-full mt-4 bg-[#D94E18] hover:bg-[#C2410C]" data-testid="upload-files-btn">
              {uploading ? (
                <span className="flex items-center gap-2">
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />Processing...
                </span>
              ) : (
                `Upload & Process ${files.length} File${files.length > 1 ? 's' : ''}`
              )}
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
